module.exports = __webpack_public_path__ + "img/sale50procent2.e9a1fd8a.png";